module.exports = __webpack_public_path__ + "img/4New.83337d5a.png";